<div class="bp-modal mod-lg" [class.elevated]="showGreyBackground() && !isThirdStep">
  @if (isTaxesLoading) {
    <loading-spinner></loading-spinner>
  } @else {
    @if (showTradeFlow$ | async) {
      @if (currentStep; as header) {
        <legacy-order-header
          [priceSubject$]="priceSubject$"
          [offer]="data"
          [cameFromHeaderSwitch]="cameFromHeaderSwitch"
          class="font-semibold"
          [title]="header.title">
          @if (header.left; as left) {
            <a
              left
              (click)="onHeaderButtonClick(left)"
              (keydown.enter)="onHeaderButtonClick(left)"
              [tabIndex]="0">
              {{ left | translate }}
            </a>
          }
          @if (header.right; as right) {
            <a
              right
              (click)="onHeaderButtonClick(right)"
              (keydown.enter)="onHeaderButtonClick(right)"
              [tabIndex]="0">
              {{ right | translate }}
            </a>
          }
        </legacy-order-header>
      }
      <div class="bp-modal-body">
        <div
          class="bp-modal-body-section"
					[ngClass]="{
						'pb-0 mod-trade-flow': isWalletStackSelection() || isThirdStep,
						'mod-no-padding': isTradableListSelection()
					}">
          <div
						[ngClass]="{
							'bp-modal-description': isWalletStackSelection() || isSecondStep,
							'text-center pb-20 text-summary-description': isThirdStep
						}">
            @if (isWalletStackSelection()) {
              {{ "tradable_wallet_selection_stack_sell" | translate }}
            }
            @if (isSecondStep) {
              {{ "sell_choose_depot" | translate }}
            }
          </div>
          <!--
          *
          *   SELECT ASSET
          *
          -->
          @if (isFirstStep) {
            <!-- legacy logic: with `tradableId` we communicate that we have multiple wallets -->
            <!-- `tradableId` = null -> we don't have multiple wallets -->
            <!-- `tradableId` != null -> we have multiple wallets -->
            @if (!tradableId) {
              <sell-asset-list
                [isLimitOrder]="isLimitOrder"
              (assetClicked)="onTradableSelect($event)"></sell-asset-list>
            }
            @if (tradableId) {
              <tradable-wallet
                [ngClass]="'modal-grid mod-two-cols'"
                [action]="'sell'"
                [tradableWallets]="wallets"
                (onSelect)="selectWallet($event)"
                [(tradableId)]="tradableId">
              </tradable-wallet>
            }
          }
          <!--
          *
          *   SELECT ACCOUNT
          *
          -->
          @if (isSecondStep) {
            <div class="modal-grid mod-two-cols">
              @if (cashPlusFiatTilesVM$ | async; as vm) {
                @for (asset of vm.cashPlusFiatWallets; track asset) {
                  <cashplus-fiat-tile
                    [asset]="asset"
                    [defaultFiat]="asset.defaultFiat"
                    [isCashPlusOptIn]="asset.isOptIn"
                    [isCashPlusEligible]="asset.isEligible"
                    (click)="selectCashPlusFiatWallet(asset)"
                    (keydown.enter)="selectCashPlusFiatWallet(asset)"
                    class="grid-item card-interactive">
                  </cashplus-fiat-tile>
                }
                @for (fw of vm.remainingFiatWallets; track fw; let i = $index) {
                  <fiat-wallet-tile
                    [ngClass]="'grid-item'"
                    [wallet]="fw"
                    (click)="selectFiatWallet(fw)"
                    [active]="isSame(fw, fiatWallet)"
                    tabindex="50+i"
                    (keydown.enter)="selectFiatWallet(fw)">
                  </fiat-wallet-tile>
                }
              } @else {
                @for (fw of getFiatWallets(); track fw._id; let i = $index) {
                  @if (fw?.getCurrencyId() | fiat_exists_check) {
                    <fiat-wallet-tile
                      [ngClass]="'grid-item'"
                      [wallet]="fw"
                      (click)="selectFiatWallet(fw)"
                      [active]="isSame(fw, fiatWallet)"
                      tabindex="50+i"
                      (keydown.enter)="selectFiatWallet(fw)">
                    </fiat-wallet-tile>
                  }
                }
              }
            </div>
          }
          <!--
          *
          *   AMOUNTS
          *
          -->
          @if (isThirdStep) {
            <div class="modal-grid mod-three-cols mod-in-modal mod-center">
              @for (conversion of getAmounts(); track conversion) {
                <tradable-amount-tile
                  [ngClass]="'grid-item'"
                  [bfcOptIn]="data?.bestFeeOptIn"
                  (click)="setAmount(conversion)"
                  [fiat]="getFiat()"
                  [showSmallAmount]="!isIndexTrade()"
                  [conversion]="conversion"
                  [tradable]="getTradable()"
                (keydown.enter)="setAmount(conversion)"></tradable-amount-tile>
              }
              <tradable-amount-tile
                [ngClass]="'grid-item'"
                (click)="setToMax()"
                [bfcOptIn]="data?.bestFeeOptIn"
                [conversion]="maxAmount()"
                [all]="true"
                [fiat]="getFiat()"
                [inverse]="true"
                [tradable]="getTradable()"
                (keydown.enter)="setToMax()">
              </tradable-amount-tile>
            </div>
          }
        </div>
        @if (priceSubject$ | async; as defaultPrice) {
          <div
            class="bp-modal-body-section mod-fullwidth pt-30"
            [ngClass]="{ 'pb-15': showDerivativeFooter() }">
            <div class="items-start flex-wrap modal-internal-transfer mod-input">
              <bp-input
                class="mod-input-line"
                iconLeading="true"
                [iconUrl]="icon"
                [iconUrlAltText]="'logo_alt_text' | translate"
                min="0"
                name="amount_fiat"
                [step]="getStepsFromOfferFiat()"
                (keydownEnter)="getOffer()"
                [type]="getInputFormat()"
                required
                autofocus
                [(value)]="amount"
                [formGroupClass]="false"
                (onFocus)="inputOnFocus($event)"
                (onFocusOut)="inputOnFocusOut($event)"
                (valueChange)="inputModelChange($event)"
                bpInputNumberLeadingTrailingDot
                [trailingDotPrecision]="userWantsTradable ? getTradable().getPrecision() : 2">
                @if (!isIndexTrade()) {
                  <a
                    right
                    (click)="change()"
                    class="hover-pointer"
                    href="javascript:"
                    >
                    @if (isNotIndexNorTokenTrade()) {
                      <span
											[ngClass]="{
												'text-transparent font-size-13': getSelectedCurrency() !== 'cryptocoin',
												'text-highlight font-size-17': getSelectedCurrency() === 'cryptocoin'
											}">
                        {{ getTradable()?.getSymbol() }}
                      </span>
                      /
                      <span
											[ngClass]="{
												'text-transparent font-size-13': getSelectedCurrency() !== 'fiat',
												'text-highlight font-size-17': getSelectedCurrency() !== 'cryptocoin'
											}">
                        {{ getFiat()?.getSymbol() }}
                      </span>
                    } @else {
                      <img
                        src="{{ getTradable().getLogo() }}"
                        [class.selected-icon]="getSelectedCurrency() === 'cryptocoin'"
                        alt="{{ getTradable().getName() }}" />
                      /
                      <img
                        src="{{ getFiat().getLogo() }}"
                        [class.selected-icon]="getSelectedCurrency() !== 'cryptocoin'" />
                    }
                  </a>
                }
              </bp-input>
            </div>
            <!-- labels: min amount + fees info -->
            <div class="bp-modal-row mt-10 bp-modal-custom-margin modal-internal-transfer mod-input">
              <div class="bp-modal-column left">
                {{ "minimum" | translate }}:
                {{ min() | fiat_precision_symbol: { id: getFiat()?.getId(), currencies: [getFiat()] } }}
              </div>
              @if (!isIndexTrade()) {
                <div class="bp-modal-column right text-gray">
                  @if (getTradable().getCurrencyType() !== assetType.SECURITY_TOKEN) {
                    {{
                    1
                    | tradable_precision_symbol
                    : { id: getTradable().getId(), removePrecision: true }
                    }}
                  } @else {
                    1 {{ "fma_unit_one" | translate }}
                  }
                  &asymp;
                  {{
                  getPriceFiat()
                  | fiat_precision_symbol
                  : { id: getFiat()?.getId(), currencies: [getFiat(), getTradable()] }
                  }}
                </div>
              }
            </div>
            <!-- Leveraged info amount screen -->
            @if (isLeveragedToken()) {
              <div class="l-token-info-wrapper hide">
                <leveraged-token-info-amount
                  [vm]="leverageTokenViewModel$ | async"
                  [amountInput]="getAmountFiat()">
                </leveraged-token-info-amount>
              </div>
            }
            <!-- Info box -->
            <instant-trade-bonus [step]="getItbStep()" [tradeData]="getItbData()"></instant-trade-bonus>
            <ng-container *featureVisibility="featureList.STAKING_GLOBAL">
              @if (isAssetStaked$ | async) {
                <div class="pl-30 pr-30 pt-20">
                  <bp-info-box>{{ "staking_trade_flow_warning_sell" | translate }}</bp-info-box>
                </div>
              }
            </ng-container>
            <hr class="mb-20 mt-30" />
            <div class="pl-50 pr-50">
              @if (!isIndexTrade()) {
                <div
                  class="bp-modal-row font-size-24"
									[ngClass]="{
										'text-light': data?.getAmountTradable() === 0
									}">
                  <div class="bp-modal-column left mr-5">{{ "amount_total" | translate }}</div>
                  <div class="bp-modal-column right break">
                    <strong>
                      {{
                      getAmountTradable()
                      | tradable_precision_symbol
                      : {
                      id: getTradable()?.getId(),
                      ignorePrecision: true,
                      removeCurrency:
                      getTradable().getCurrencyType() ===
                      assetType.SECURITY_TOKEN
                    }
                    }}
                    @if (getTradable().getCurrencyType() === assetType.SECURITY_TOKEN) {
                      <security-token-unit-display
                      [amount]="getAmountTradable()"></security-token-unit-display>
                    }
                  </strong>
                </div>
              </div>
              <div class="bp-modal-row font-size-15">
                <div class="bp-modal-column left text-opaque"></div>
                <div class="bp-modal-column right break color-black">
                  &asymp;
                  {{
                  getAmountFiat()
                  | fiat_precision_symbol
                  : { id: getFiat()?.getId(), currencies: [getFiat()] }
                  }}
                </div>
              </div>
            } @else {
              <div
                class="bp-modal-row font-size-24"
									[ngClass]="{
										'text-light': data?.getAmountTradable() === 0
									}">
                <div class="bp-modal-column left mr-5">{{ "amount" | translate }}</div>
                <div class="bp-modal-column right break">
                  <strong>
                    {{
                    getAmountFiat()
                    | fiat_precision_symbol
                    : {
                    id: getFiat()?.getId(),
                    currencies: [getFiat()],
                    symbol: true
                  }
                  }}
                </strong>
              </div>
            </div>
          }
        </div>
        <div class="pl-30 pr-30 mt-20 text-center">
          <button
            class="btn btn-primary btn-lg btn-summary mod-amount"
            type="button"
            (click)="getOffer()">
            {{ "goto_summary_trade_sell_button" | translate }}
          </button>
        </div>
        @if (showDerivativeFooter()) {
          <div class="trade-modal_powered_by_stocks">
            {{ "stocks_powered_by" | translate }}
          </div>
        }
      </div>
    }
  </div>
} @else {
  @if (summary) {
    <tradable-trade-summary
      [data]="data"
      [taxWithheld]="taxWithheld$ | async"
      [shouldCallGql]="shouldCallGql()"
      (edit)="setEdit($event)"
      [itbData]="getItbData()"
      (finish)="showSuccessScreen($event)"
      (onClose)="closeFromError($event)"
      (onReceiveTradeId)="updateTradeId($event)"
      (onTaxWitheldUpdate)="refreshTaxWithheld($event)">
    </tradable-trade-summary>
  }
}
}
</div>
